export const ERROR = 'property/ERROR';
export const PROPERTY_LIST = 'property/PROPERTY_LIST';
export const FLUSH = 'FLUSH';
export const LOGOUT = 'property/LOGOUT';
export const MESSAGE = 'property/MESSAGE';
export const PROPERTY_DETAILS = 'property/PROPERTY_DETAILS';
export const PROPERTY_REVIEWS = 'property/PROPERTY_REVIEWS';
export const TIMELINE_DETAILS = 'property/TIMELINE_DETAILS';